import type { TFunction } from 'i18next';

import { z } from 'zod';

export const createSummarySchema = (t: TFunction) =>
  z.object({
    summary: z.string().min(1, { message: t('Forms.Summary.errors.summary') }),
  });

export type SummaryFormValues = z.infer<ReturnType<typeof createSummarySchema>>;
